import { fetchJSON } from "lib/fetch";
import { getConfig } from "site-config";
import { SMART_ORDERS } from "./action-types";

export const fetchSmartOrdersStart = () => ({
    type: SMART_ORDERS.FETCH.START,
});

export const fetchSmartOrdersSuccess = (payload: TSmartOrders) => ({
    type: SMART_ORDERS.FETCH.SUCCESS,
    payload,
});

export const fetchSmartOrdersError = (payload: any) => ({
    type: SMART_ORDERS.FETCH.ERROR,
    payload,
});

export type TSmartOrder = {
    id: string;
    brand_id: string;
    city: string;
    company_id: string;
    company_name: string;
    buyer_id: string;
    buyer_name: string;
    buyer: {
        _id: string;
        name: string;
        rseriesAccountId: string;
        companies: {
            _id: string;
            name: string;
            addresses: {
                _id: string;
                country: string;
                default_billing: boolean;
                default_shipping: boolean;
                type: string;
                display_name: string;
                shipping_code?: string;
                line_1: string;
                line_2?: string;
                city: string;
                state: string;
                zip: string;
                warehouse: string;
            }[];
        }[];
    };
    merchant_name: string;
    state: string;
    zip_code: string;
    total_qty: number;
};

export type TSmartOrders = {
    orders: TSmartOrder[];
    meta: {
        report_date: string;
        total_count: number;
    };
};

export const fetchSmartOrders = (dispatch) => {
    const { api } = getConfig();

    dispatch(fetchSmartOrdersStart());
    return fetchJSON<TSmartOrders>(`${api}/api/v3.0/smart-orders`, {
        method: "GET",
    })
        .then((data) => {
            dispatch(fetchSmartOrdersSuccess(data));
        })
        .catch((error) => {
            dispatch(fetchSmartOrdersError(error));
        });
};
